import { createActionCreator } from 'deox';

import { AppsInfo } from '@/types';
import { AppInfoForm } from '@/services/service-directory/app-info';

export const fetchAppsInfoActions = {
  request: createActionCreator('FETCH_APPS_INFO_REQUEST', (resolve) => (entityId: string) => resolve({ entityId })),
  success: createActionCreator('FETCH_APPS_INFO_SUCCESS', (resolve) => (appsInfo: AppsInfo) => resolve(appsInfo)),
  failure: createActionCreator('FETCH_APPS_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
  reset: createActionCreator('FETCH_APPS_INFO_RESET'),
};

export const createAppInfoActions = {
  request: createActionCreator('CREATE_APP_INFO_REQUEST', (resolve) => (appInfo: AppInfoForm) => resolve({ appInfo })),
  success: createActionCreator('CREATE_APP_INFO_SUCCESS'),
  failure: createActionCreator('CREATE_APP_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const editAppInfoActions = {
  request: createActionCreator('EDIT_APP_INFO_REQUEST', (resolve) => (id: string, appInfo: AppInfoForm) =>
    resolve({ id, appInfo })
  ),
  success: createActionCreator('EDIT_APP_INFO_SUCCESS'),
  failure: createActionCreator('EDIT_APP_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const deleteAppInfoActions = {
  request: createActionCreator('DELETE_APP_INFO_REQUEST', (resolve) => (id: string) => resolve({ id })),
  success: createActionCreator('DELETE_APP_INFO_SUCCESS'),
  failure: createActionCreator('DELETE_APP_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const scrapeAppInfoActions = {
  request: createActionCreator(
    'SCRAPE_APP_INFO_REQUEST',
    (resolve) => (id: string, playStoreLink?: string, appStoreLink?: string) =>
      resolve({ id, playStoreLink, appStoreLink })
  ),
  success: createActionCreator('SCRAPE_APP_INFO_SUCCESS'),
  failure: createActionCreator('SCRAPE_APP_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const createAndScrapeAppInfoActions = {
  request: createActionCreator('CREATE_SCRAPE_APP_INFO_REQUEST', (resolve) => (urlScrape: string) =>
    resolve({ urlScrape })
  ),
  success: createActionCreator('CREATE_SCRAPE_APP_INFO_SUCCESS'),
  failure: createActionCreator('CREATE_SCRAPE_APP_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
